import Radio from 'backbone.radio';
import MFAKeysMgmt from '@/views/dialogs/mfa_keys_management';

var globalCh = Radio.channel('global');

export default function show_mfa_keys_mgmt(collection, model) {
    var dialog = new MFAKeysMgmt({
        collection: collection,
        model: model,
    });
    globalCh.request('showDialog', dialog);
}
